import React from 'react';
import {PWMCheckedIcon, PWMXIcon} from './PWMIcons';

const PWMIsChecked: React.FC<IPWMIsCheckedProps> = (props) => {
  return props.checked ? <PWMCheckedIcon htmlColor="green" /> : <PWMXIcon />;
}

export default PWMIsChecked;

interface IPWMIsCheckedProps {
  children?: React.ReactNode;
  checked: boolean;
}